import io from "socket.io-client";
import {
    //    FEACH_UPDATE_STATE
} from "./type";
import { API_ENDPOINT } from "../../AppConfig";
let socket = null;

export function initStatus() {
    return (dispatch, getState) => {
        socket = io(`${API_ENDPOINT}/utils`, {
            query: {
                // id: JSON.parse(localStorage.getItem("JAZANuser")) && JSON.parse(localStorage.getItem("JAZANuser")).id
            }
        });
        socket.on('connect', () => { console.log('SOCKEETTTT connectsockettype', socket) });

        socket.on('UpdateStatus', data => {
            console.log("SOCKEETTTT UpdateStatus:", data)
            //    dispatch({ type:FEACH_UPDATE_STATE, payload: data });
        })
    }
}